import axios from "axios";

export default {
  namespaced: true,
  state: {
    claims: [],
    requests: [],
    reimbursements: [],
    statements: [],
    policies: [],
    policy: null,
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    claimsMessage: ''
  },
  mutations: {
    SET_POLICY(state, payload) {
      state.policy = payload;
      console.log("setPolicy", state.policy)
    },
    RECEIVED_CLAIMS(state, payload) {
      state.claims = payload;
      state.isReceiving = false;
    },
    RECEIVED_REQUESTS(state, payload) {
      state.requests = payload;
      state.isReceiving = false;
    },
    RECEIVED_REIMBURSEMENTS(state, payload) {
      state.reimbursements = payload;
      state.isReceiving = false;
    },
    RECEIVED_POLICIES(state, payload) {
      state.policies = payload;
      state.isReceiving = false;
    },
    RECEIVED_STATEMENTS(state, payload) {
      state.statements = payload;
      state.isReceiving = false;
    },
    RECEIVING_CLAIMS(state) {
      state.isReceiving = true;
    },
    RECEIVING_REQUESTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_REIMBURSEMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_POLICIES(state) {
      state.isReceiving = true;
    },
    RECEIVING_STATEMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_CLAIM(state) {
      state.isReceiving = true;
    },
    RECEIVED_CLAIM(state, payload) {
      state = Object.assign(state, {
        claims: [...state.claims, payload],
        isReceiving: false,
      })
    },
    RECEIVED_REQUEST(state, payload) {
      state = Object.assign(state, {
        requests: [...state.requests, payload],
        isReceiving: false,
      })
    },
    UPDATED_CLAIMS(state, payload) {
      console.log(state.claims);
      console.log(payload);
      let index = state.claims.findIndex(claim => claim._id === payload._id);
      state = Object.assign(state, {
        claims: state.claims.map((claim, i) => {
          if (i === index) {
            return Object.assign({}, claim, payload);
          }
          return claim;
        }),
        isUpdating: false,
        claimsMessage: 'Claims has been updating!',
      })
    },
    UPDATING_CLAIMS(state) {
      state.isUpdating = true;
    },
    DELETED_CLAIMS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.claims.findIndex(claim => claim._id === payload._id);
      console.log(indexToDelete);
      let claims = [...state.claims];
      claims.splice(indexToDelete, 1);
      state = Object.assign(state, {
        claims: [...claims],
        isDeleting: false,
        idToDelete: null,
        claimsMessage: 'Claim has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_CLAIMS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertClaimRequest({dispatch}, payload) {
      dispatch("receivingClaims");
      let data, headers;
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/claim';
      if(payload.filedata==null || payload.filedata==undefined){
        data = payload;
        headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      }
      else{
        data = new FormData();
        data.append('file', payload.filedata, payload.filename); 
        delete payload['filedata'];
        delete payload['filename'];
        data.append('payload', JSON.stringify(payload));
        headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      }
      let post = {method: "post", url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {
        let claim = Object.assign({}, response.data.claim);
        claim.transactions = response.data.transactions;
        dispatch("receiveClaim", claim);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async insertRequestRequest({dispatch}, payload) {
      dispatch("receivingRequests");
      let data, headers;
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/request';
      if(payload.filedata==null || payload.filedata==undefined){
        data = payload;
        headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      }
      else{
        data = new FormData();
        data.append('file', payload.filedata, payload.filename); 
        delete payload['filedata'];
        delete payload['filename'];
        data.append('payload', JSON.stringify(payload));
        headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      }
      let post = {method: "post", url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {
        dispatch("receiveRequest", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    SetPolicy({dispatch}, payload) {
      dispatch("setPolicy", payload);
    },
    async getMyClaimsRequest({dispatch}) {
      dispatch("receivingClaims");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/my/claims';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers});
      dispatch("receiveClaims", response.data);
      return response.data;
    },
    async getMyReimbursementsRequest({dispatch}) {
      dispatch("receivingReimbursements");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/my/reimbursements';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers});
      dispatch("receiveReimbursements", response.data);
      console.log(response.data)
      return response.data;
    },
    async getMyRequestsRequest({dispatch}) {
      dispatch("receivingRequests");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/my/requests';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers});
      dispatch("receiveRequests", response.data);
      return response.data;
    },
    async getMyPoliciesRequest({dispatch}) {
      dispatch("receivingPolicies");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/my/policies';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers});
      console.log(response.data);
      dispatch("receivePolicies");
      return response.data
    },
    async getMyStatementsRequest({dispatch}) {
      dispatch("receivingStatements");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/my/statements';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers});
      dispatch("receiveStatements");
      return response.data;
    },
    setPolicy({commit}, payload) {
      commit("SET_POLICY", payload)
    },
    receiveClaims({commit}, payload) {
      commit("RECEIVED_CLAIMS", payload)
    },
    receiveRequests({commit}, payload) {
      commit("RECEIVED_REQUESTS", payload)
    },
    receiveReimbursements({commit}, payload) {
      commit("RECEIVED_REIMBURSEMENTS", payload)
    },
    receivePolicies({commit}, payload) {
      commit("RECEIVED_POLICIES", payload)
    },
    receiveStatements({commit}, payload) {
      commit("RECEIVED_STATEMENTS", payload)
    },
    receivingClaims({commit}) {
      commit("RECEIVING_CLAIMS")
    },
    receivingRequests({commit}) {
      commit("RECEIVING_REQUESTS")
    },
    receivingReimbursements({commit}) {
      commit("RECEIVING_REIMBURSEMENTS")
    },
    receivingPolicies({commit}) {
      commit("RECEIVING_POLICIES")
    },
    receivingStatements({commit}) {
      commit("RECEIVING_STATEMENTS")
    },
    receiveClaim({commit}, payload) {
      commit("RECEIVED_CLAIM", payload)
    },
    receiveRequest({commit}, payload) {
      commit("RECEIVED_REQUEST", payload)
    },
    receivingClaim({commit}) {
      commit("RECEIVING_CLAIMS")
    },
    updateClaim({commit}, payload) {
      commit("UPDATED_CLAIMS", payload)
    },
    updatingClaim({commit}) {
      commit("UPDATING_CLAIMS")
    },
    deleteClaim({commit}, payload) {
      commit("DELETED_CLAIMS", payload)
    },
    deletingClaim({commit}, payload) {
      commit("DELETING_CLAIMS", payload)
    }
  },
};
